interface ResetConfirmDialogProps {
  open: boolean
  onConfirm: () => void
  onClose: () => void
}

export function ResetConfirmDialog({ open, onConfirm, onClose }: ResetConfirmDialogProps) {
  if (!open) return null

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.35)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9998,
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: '#fff',
          borderRadius: 12,
          padding: '28px 32px',
          maxWidth: 400,
          width: '100%',
          boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ fontSize: 15, fontWeight: 600, color: '#111827', marginBottom: 10 }}>
          Сбросить вид таблицы?
        </div>
        <div style={{ fontSize: 13, color: '#6b7280', marginBottom: 24 }}>
          Порядок столбцов, ширина, закрепление и фильтры вернутся к стандартным настройкам.
        </div>
        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
          <button
            onClick={onClose}
            style={{
              padding: '7px 18px',
              fontSize: 13,
              border: '1px solid #d1d5db',
              borderRadius: 8,
              cursor: 'pointer',
              background: '#fff',
              color: '#374151',
            }}
          >
            Нет
          </button>
          <button
            onClick={onConfirm}
            style={{
              padding: '7px 18px',
              fontSize: 13,
              border: 'none',
              borderRadius: 8,
              cursor: 'pointer',
              background: '#2563eb',
              color: '#fff',
            }}
          >
            Да, сбросить
          </button>
        </div>
      </div>
    </div>
  )
}
